exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 768px) {\n}\n@media (max-width: 767px) {\n}\n@media (max-width: 767px) {\n}\n@media (min-width: 768px) {\n}\n.isLetterpressTag___2tMLP {\n  margin: 10px 0;\n  font-weight: 700;\n  color: #276588 !important;\n  background-color: #ebf1f9 !important;\n  border: none !important;\n}\n", ""]);

// exports
exports.locals = {
	"isLetterpressTag": "isLetterpressTag___2tMLP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/cards/components/CardListing/ListingDetail/styles.module.less
// module id = 1154
// module chunks = 47